import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as p5 from 'p5';
import { FullScreenService } from 'src/app/service/fullscreen.service';

@Component({
  selector: 'app-actual-test',
  templateUrl: './actual-test.component.html',
  styleUrls: ['./actual-test.component.css']
})
export class ActualTestComponent implements OnInit {

  @Input() rX: number
  @Input() rY: number
  @Input() fullScreen: boolean
  @Input() setFullScreen
  @Input() setAnswers
  @Input() save

  //strings for translations
  msg1: string
  msg2: string
  msg3: string
  msg4: string

  constructor(public fullScreenService: FullScreenService, public translate: TranslateService) {
    this.getTranslatedStrings()
  }

  getTranslatedStrings() {
    this.translate.get(['ROUND', 'OF', 'MP_P20', 'MP_P21'])
      .subscribe(translations => {
        this.msg1 = translations['ROUND']
        this.msg2 = translations['OF']
        this.msg3 = translations['MP_P20']
        this.msg4 = translations['MP_P21']
      })
  }

  ngOnInit(): void {

    this.setFullScreen(true)
    this.fullScreenService.setFullScreen(true)
    const setFullScreenParam = this.fullScreenService.setFullScreen

    let order = (Math.floor(Math.random() * 2) + 1).toString()
    switch (order) {
      case '1':
        var adapBlock = "0";
        break;
      case '2':
        var adapBlock = "1";
        break;
    }
    let rX = this.rX
    let rY = this.rY
    const answers = []
    const setAns = this.setAnswers
    const setFull = this.setFullScreen
    const saveTest = this.save

    var windowWH = [window.screen.width, window.screen.height]

    //translations
    let msg1 = this.msg1
    let msg2 = this.msg2
    let msg3 = this.msg3
    let msg4 = this.msg4

    let adapDir = 0;
    /* create sketch environment */
    var sketch = function (p) {
      // set the environment for scaling everything depending on the resolution
      let scaleX = p.float(rX);
      let scaleY = p.float(rY);
      let scale = (scaleX + scaleY) / 2;

      var trialState; // number to keep track of the stage the trial is in
      var trialCount; // counter for the trial number in the block
      let trialN = 20; // the overall number of trials in a sequence
      var trial;
      var fs = false; // flag for full screen representation or not
      var timeout = false; // flag for whether the trial setting has timed out or not
      var timeoutCount = 0; // counter to check if timeouts for certain trials and if so how many

      let adapTime = 7000; //timing for adaptation stimulus
      let testTime = 500; // timing for test stimulus
      var timeCheck;
      let canClick = false; // allows to click only when the round showed everything

      // set parameters for motion stimulus (nrdots dot size etc)
      let nrDots = 600;
      let dotSize = 1 * scale;
      let adapSpeed = 48 * scale; //mm per second
      let testSpeed = 6 * scale; //mm per second
      //		let dotDir = 0;
      // var adapDir = 0;
      let testDirSet = [-90, 90];
      var testDir, testDirID;
      let patchR = 60 * scale;
      var dotCoords_X = Array(nrDots);
      var dotCoords_Y = Array(nrDots);
      var glassDir;
      let glassR = 2 * scale; // 2mm offset for the glass pattern
      var timestamp, curTime, lastTime, dt;

      // parameters for apparent motion
      let nrRect = 5;
      let rectSize = 10 * scale;
      let dutyCycle = [150, 150, 300, 1000, 1050];
      let cycleT = dutyCycle[4];
      var flashCycleStart;
      var cycleState;

      let nrArrows = 200;
      let arrL = 5 * scale;
      var arrCoords_X = Array(nrArrows);
      var arrCoords_Y = Array(nrArrows);

      let correctAnswersCount = 0


      /*-----------------*/

      p.preload = function () {

        resetCoords();

      }

      /*-----------------*/

      p.setup = function () {
        var canvas = p.createCanvas(windowWH[0], windowWH[1]);
        canvas.parent('sketch-holder-' + adapBlock);
        canvas.style('display', 'block')
        fs = p.fullscreen(true);
        window.scrollTo(0, document.body.scrollHeight);
        // call the createAdapImage function to make the adaptation image(s) for this block of trials

        switch (adapBlock) {
          case '0':
            // adapSpeed unchanged
            adapDir = 0; // normal motion
            break;
          case '1':
            adapDir = 180;
            break;
        }
        //console.log(adapBlock, adapDir)

        // initialize the experiment			
        trialState = 0; // set the trial state to zero for the first trial
        trialCount = 0; // set the trial counter to zero
        // get the condition for the first trial
        trial = trialCount;
        //			trialCon = dotDir;
        glassDir = 0;
        cycleState = 0;
        testDirID = 0;
        testDir = testDirSet[testDirID];

        timestamp = p.millis(); // get an initial timestamp
        setTimeout(() => {
          canClick = true;
        }, adapTime+testTime);
      }

      /*-----------------*/
      
      p.draw = function () {
        p.background(128);
        p.angleMode(p.DEGREES);
        p.noCursor();

        // set the format for any text to display
        p.fill(255, 255, 255);
        p.textSize(25);
        //			p.text('AdapBlock = ' + adapBlock,10,40);
        //			p.text(p.mouseX+'   '+p.mouseY,20,windowWH[1]-20);
        const countDisplayed = trialCount + 1 <= trialN ? trialCount + 1 : trialN;
        p.text(msg1 + ' ' + (countDisplayed) + ' ' + msg2 + ' ' + trialN, 20, 30);

        // figure out what to draw in relation to the current state of the trial
        // curTime = p.millis();
        switch (trialState) {
          case 0: // adaptation stimulus
            // check if end of adaptation period
            if ((curTime - timestamp) > adapTime) {
              //						console.log("check timing ", curTime, timestamp, curTime - timestamp );
              resetCoords();
              //						dotDir = 90;
              trialState = trialState + 1;
              timeout = false;
              timeCheck = curTime - timestamp;
              timestamp = p.millis(); // get an initial timestamp
              curTime = timestamp;
            }

            lastTime = curTime;
            curTime = p.millis();
            dt = (curTime - lastTime) / 1000;

            // update the dots
            updateAndDrawCoords(dt, adapDir, adapSpeed);

            break;
          case 1: // test stimulus
            // check if end of adaptation period
            if ((curTime - timestamp) > testTime) {
              //						console.log("check timing ", curTime, timestamp, curTime - timestamp );
              resetCoords();
              //						dotDir = 0;
              trialState = trialState + 1;
              timeout = false;
              timeCheck = curTime - timestamp;
              timestamp = p.millis(); // get an initial timestamp
              curTime = timestamp;
            }

            lastTime = curTime;
            curTime = p.millis();
            dt = (curTime - lastTime) / 1000;

            updateAndDrawCoords(dt, testDir, testSpeed);

            break;
          case 2: // response
            // draw response stimulus
            createResponsePattern();
            break;
          case 3:
            const textW = p.textWidth(msg3 + ' ' + correctAnswersCount + ' ' + msg4 + '' + trialN +'.')

            //compute text offset according to text width and text container width (that is windowWH[0] / 2)
            const textOffset = textW > (windowWH[0] / 2) ? (windowWH[0] / 4) : (textW / 2)
            p.text(msg3 + ' ' + correctAnswersCount + ' ' + msg4 + '' + trialN +'.',
              windowWH[0] / 2 - textOffset, windowWH[1] / 2, windowWH[0] / 2);
            break;
        }

      }


      /*-----------------*/

      function createResponsePattern() {
        // get mouse postion to set the orientation
        glassDir = p.atan2(p.mouseY - windowWH[1] / 2, p.mouseX - windowWH[0] / 2);
        // create the glass response pattern
        p.push();// Start a new drawing state
        p.translate(windowWH[0] / 2, windowWH[1] / 2);
        // draw arrows for responses
        p.stroke(255);
        for (var ii = 0; ii < nrArrows; ii++) {
          if ((p.pow(arrCoords_X[ii], 2) + p.pow(arrCoords_Y[ii], 2)) < p.pow(patchR, 2)) {
            drawArrow(arrCoords_X[ii], arrCoords_Y[ii], glassDir);
          }
        }
        p.pop();


        p.push();// Start a new drawing state for the fixation dot in the middle
        p.translate(windowWH[0] / 2, windowWH[1] / 2);
        p.noStroke();
        p.fill(128);
        p.ellipse(0, 0, 20 * scale);
        p.fill(0, 255, 0);
        p.ellipse(0, 0, 2 * scale);
        p.pop();

      }


      /*-----------------*/

      function resetCoords() {
        // set up initial dot coordinates
        for (var ii = 0; ii < nrDots; ii++) {
          dotCoords_X[ii] = p.random(-patchR, patchR);
          dotCoords_Y[ii] = p.random(-patchR, patchR);
        }

        // also reset arrow coordinates
        for (var ii = 0; ii < nrArrows; ii++) {
          arrCoords_X[ii] = p.random(-patchR, patchR);
          arrCoords_Y[ii] = p.random(-patchR, patchR);
        }

        curTime = p.millis();
      }

      function updateAndDrawCoords(dt, dotDir, dotSpeed) {
        // update and draw dots
        //			console.log(dotDir);
        p.push();// Start a new drawing state
        p.translate(windowWH[0] / 2, windowWH[1] / 2);
        //draw dots
        p.noStroke();
        p.fill(255);
        for (var ii = 0; ii < nrDots; ii++) {
          // draw the dot if within a circular apperture
          if ((p.pow(dotCoords_X[ii], 2) + p.pow(dotCoords_Y[ii], 2)) < p.pow(patchR, 2)) {
            p.ellipse(dotCoords_X[ii], dotCoords_Y[ii], dotSize);
            //					console.log(dotCoords_X[ii],dotCoords_Y[ii],dotCoords_X[ii]^2,dotCoords_Y[ii]^2,patchR^2)
          }
          // update position
          dotCoords_X[ii] += p.cos(dotDir) * dotSpeed * dt;
          //check if running out of bounds
          if (dotCoords_X[ii] >= patchR) {
            dotCoords_X[ii] -= 2 * patchR;
          } else if (dotCoords_X[ii] <= -patchR) {
            dotCoords_X[ii] += 2 * patchR;
          }
          dotCoords_Y[ii] += p.sin(dotDir) * dotSpeed * dt;
          //check if running out of bounds
          if (dotCoords_Y[ii] >= patchR) {
            dotCoords_Y[ii] -= 2 * patchR;
          } else if (dotCoords_Y[ii] <= -patchR) {
            dotCoords_Y[ii] += 2 * patchR;
          }

        }
        p.pop();

        p.push();// Start a new drawing state for the fixation dot in the middle
        p.translate(windowWH[0] / 2, windowWH[1] / 2);
        p.noStroke();
        p.fill(128);
        p.ellipse(0, 0, 20 * scale);
        p.fill(0, 255, 0);
        p.ellipse(0, 0, 2 * scale);
        p.pop();

      }


      function drawArrow(x, y, dir) {
        p.push();
        p.translate(x, y);
        p.rotate(dir);
        p.line(-arrL / 2, 0, arrL / 2, 0);
        p.line(arrL / 2 - arrL / 5, -arrL / 5, arrL / 2, 0);
        p.line(arrL / 2 - arrL / 5, arrL / 5, arrL / 2, 0);
        p.pop();
      }

      /*-----------------*/

      p.mousePressed = function () {
        console.log("canclick:", canClick)

        if (canClick) {
          canClick=false;
          setTimeout(() => {
            canClick = true;
          }, adapTime+testTime);
        const newRow = {
          'adapDir': adapDir,
          'trialnr': trial,
          'testDir': testDir,
          'response': glassDir,
          'time_ms': p.int(p.millis() - timestamp),
          'timecheck': timeCheck
        }
        
        answers.push(newRow)
        console.log(newRow)

        //if correct, increment counter
        if ((glassDir >= 0 && testDir > 0) || (glassDir < 0 && testDir < 0))
          correctAnswersCount++

        // reset timoutCount if necessary
        timeoutCount = 0;

        // go to next trial if end not yet reached
        trialCount = trialCount + 1;
        
        // RT: revert direction after half the trials
        if (trialCount===trialN/2) {
          adapDir===0 ? adapDir=180 : adapDir = 0; 
        }
        
        if (trialCount < trialN) {
          trial = trialCount;
          testDirID = p.abs(testDirID - 1);
          testDir = testDirSet[testDirID];

          trialState = 0;
          timestamp = p.millis(); // get an initial timestamp
          flashCycleStart = timestamp;
        } else {
          // if end of trial list reached
          trialState++ //show feedback
          //close feedback and end task after 4 seconds
          setTimeout(() => {
            p.finished()
          }, 4000)
        }
      }
    }


      /*-----------------*/

      p.finished = function () {
        // save the data 
        switch (adapBlock) {
          case '0':
            // adaptation normal
            answers.forEach((ans) => ans.adaptation = 'normal')
            break;
          case '1':
            // adaptation apparent motion
            answers.forEach((ans) => ans.adaptation = 'apparent motion')
            break;
        }

        // close p5 and continue to next question in the survey
        setFullScreenParam(false)
        p.fullscreen(false);
        setAns(answers)
        setFull(false)
        p.remove();
        saveTest()

      }

    };

    /* end of sketch environment */
    var myp5 = new p5(sketch);

  }



}
